import store from "../store";
export const encryptionPhoneNumber = (phoneNumber) => {
  //管理员不隐藏
  console.log(phoneNumber);
  if (!phoneNumber) {
    return phoneNumber;
  }
  // 根据长度处理
  if (phoneNumber.length === 11) {
    // 11位手机号，替换中间四个星号
    return phoneNumber.substring(0, 3) + "****" + phoneNumber.substring(7);
  } else {
    // 其他长度，中间替换长度-2个星号
    if (phoneNumber.length <= 2) {
      return "*".repeat(phoneNumber.length);
    } else {
      let numAsterisks = phoneNumber.length - 2;
      let part1Length = (phoneNumber.length - numAsterisks) / 2;
      let part2Start = part1Length + numAsterisks;
      let asterisks = "*".repeat(numAsterisks);
      return (
        phoneNumber.substring(0, part1Length) +
        asterisks +
        phoneNumber.substring(part2Start)
      );
    }
  }
};

export const encryptionEmail = (email) => {
  //管理员不隐藏
  if (!email ) {
    return email;
  }
  let atIndex = email.lastIndexOf("@"); // 使用lastIndexOf获取最后一个'@'的位置
  if (atIndex === -1) {
    return email;
  }

  let username = email.substring(0, atIndex);
  let domain = email.substring(atIndex);

  if (username.length <= 4) {
    // 如果用户名长度小于4，则全部替换为星号
    return "*".repeat(username.length) + domain;
  } else {
    // 用户名长度大于等于4，替换前面的长度-4个字符为星号
    let maskedPart = "*".repeat(username.length - 4);
    let visiblePart = username.substring(username.length - 4);
    return maskedPart + visiblePart + domain;
  }
};
